export default "__VITE_ASSET__OC_jdAZS__"